<template>
  <div >
        <div class="div-img-top1 body-width divcss5">
      <div class="font_zh">
        联系我们
      </div>
      <div class="font_en font_en_top">
      CONTACT US
      </div>
    </div>
    <div class="contact_body">
      <div class="contact_qrcode" >
        <img src="../../../assets/images/contactus/qrcode.png">
      </div>
      <div class="row contact_info divcss5 body-width" align="center">
        <div class="contact_phone border_right_line">
          <div class="contact_phone_icon">
            <img src="../../../assets/images/contactus/contactus_phone.png">
          </div>
          <div class="contact_phone_font website_font">
            0411-84978997
          </div>
        </div>
        <div class="contact_mail border_right_line">
          <div class="contact_mail_icon">
            <img src="../../../assets/images/contactus/contact_mail.png">
          </div>
          <div class="contact_mail_font website_font">
            sales@zlonmarine.com
          </div>
        </div>
        <div class=" contact_web border_right_line">
          <div class="contact_web_icon">
            <img src="../../../assets/images/contactus/contactus_web.png">
          </div>
          <div class="contact_web_font website_font">
            www.zlonmarine.com
          </div>
        </div>
        <div class=" contact_location">
          <div class="contact_location_icon">
            <img src="../../../assets/images/contactus/contactus_position.png">
          </div>
          <div class="contact_location_font website_font" style="text-align: left">
            <p>{{$t('contact.location1')}}<br>
              {{$t('contact.location2')}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="contact_bdmap">
        <baidu-map class="bm_view"
                   :center="center"
                   :zoom="zoom"
                   @ready="handler"
                   :auto-resize=autoResize
                   :scroll-wheel-zoom=scrollWheelZoom
        >
          <bm-marker :position="center" ></bm-marker>
        </baidu-map>
    </div>
  </div>
</template>

<script>
  import banner from "@/components/commoncoms/banner";
  export default {
    name: "contactcontent",
    components:{
      banner
    },
    data () {
      return {
        // 经纬度
        center: {lng: 0, lat: 0},
        // 缩放等级
        zoom: 3,
        //允许自适应容器尺寸
        autoResize:true,
        //允许鼠标滚轮缩放
        scrollWheelZoom:true
      }
    },
    methods: {
      handler ({BMap, map}) {
        this.center.lng = 121.5393846037
        this.center.lat = 38.8723080005
        this.zoom = 15
      }
    }
  }
</script>

<style scoped>

  .contact_qrcode{
    padding-top: 40px;
  }
  .font_zh{
    font-size: 24px;
    color: #0D3E88;
  }
  .font_en{
    font-size: 16px;
    color: #2E79BE;
  }
  .contact_info{
    padding-top: 20px;
    margin: 0px auto;
    width: 744px;
    border-bottom: 1px solid #FFFFFF;
  }
  .contact_phone_icon{
    padding: 18px 48px 10px 60px;
  }
  .contact_phone_font{
    padding:0px 14px 0px 24px;
  }
  .contact_mail_icon{
    padding: 18px 76px 10px 77px;
  }
  .contact_mail_font{
    padding: 0px 14px 0px 14px; ;
  }
  .contact_web_icon{
    padding: 18px 69px 10px 70px;
  }
  .contact_web_font{
    padding: 0px 14px 0px 14px; ;
  }
  .contact_location_icon{
    padding: 18px 113px 10px 112px;
  }
  .contact_location_font{
    padding: 0px 24px 0px 14px; ;
  }
  .website_font{
    font-size: 14px;
    color: #333333;
  }
  .contact_body{
    background: #FBFBFB;
    height:342px;
    margin-bottom: 40px !important;
text-align: center;
  }
  .border_right_line{
    background-image: url(../../../assets/images/contactus/contactus_line.png)   ;
    background-position:right 0;
    background-repeat: no-repeat ;
  }
  .bm_view{
    width: 100%;
    height: 570px;
  }
  .div-img-top1{
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/contentcoms/contactcontentcoms/contactcontent.vue